import createReactComponent from '../createReactComponent';
export default createReactComponent('parentheses', 'IconParentheses', [
  ['path', { d: 'M7 4a12.25 12.25 0 0 0 0 16', key: 'svg-0' }],
  ['path', { d: 'M17 4a12.25 12.25 0 0 1 0 16', key: 'svg-1' }],
]);
